import { SelectHTMLAttributes, forwardRef, ReactNode, useId } from "react";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  children: ReactNode;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, children, className = "", ...props }, ref) => {
    const generatedId = useId();
    const selectId = props.id ?? generatedId;
    const errorId = error ? `${selectId}-error` : undefined;
    const describedBy = [props["aria-describedby"], errorId].filter(Boolean).join(" ") || undefined;

    return (
      <div className={className}>
        {label && <label className="label-base" htmlFor={selectId}>{label}</label>}
        <select
          ref={ref}
          className="select-base"
          {...props}
          id={selectId}
          aria-describedby={describedBy}
          aria-invalid={props["aria-invalid"] ?? Boolean(error)}
        >
          {children}
        </select>
        {error && <p id={errorId} className="mt-1 text-xs text-danger">{error}</p>}
      </div>
    );
  }
);
Select.displayName = "Select";
